export interface ICarHelper {
  code: string
  description: string
  dates: string
}

export class CarCodes {
  public static Codes: ICarHelper[] = [
    {
      code: '1',
      description: 'Deductible Amount',
      dates: 'Start: 01/01/1995'
    } as ICarHelper,
    {
      code: '2',
      description: 'Coinsurance Amount',
      dates: 'Start: 01/01/1995'
    } as ICarHelper,
    {
      code: '3',
      description: 'Co-payment Amount',
      dates: 'Start: 01/01/1995'
    } as ICarHelper,
    {
      code: '4',
      description:
        'The procedure code is inconsistent with the modifier used or a required modifier is missing. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present.',
      dates: 'Start: 01/01/1995 | Last Modified: 07/01/2017'
    } as ICarHelper,
    {
      code: '5',
      description:
        'The procedure code/type of bill is inconsistent with the place of service. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present.',
      dates: 'Start: 01/01/1995 | Last Modified: 03/01/2018'
    } as ICarHelper,
    {
      code: '6',
      description:
        "The procedure/revenue code is inconsistent with the patient's age. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present.",
      dates: 'Start: 01/01/1995 | Last Modified: 07/01/2017'
    } as ICarHelper,
    {
      code: '7',
      description:
        "The procedure/revenue code is inconsistent with the patient's gender. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present.",
      dates: 'Start: 01/01/1995 | Last Modified: 07/01/2017'
    } as ICarHelper,
    {
      code: '8',
      description:
        'The procedure code is inconsistent with the provider type/specialty (taxonomy). Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present.',
      dates: 'Start: 01/01/1995 | Last Modified: 07/01/2017'
    } as ICarHelper,
    {
      code: '9',
      description:
        "The diagnosis is inconsistent with the patient's age. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present.",
      dates: 'Start: 01/01/1995 | Last Modified: 07/01/2017'
    } as ICarHelper,
    {
      code: '10',
      description:
        "The diagnosis is inconsistent with the patient's gender. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present.",
      dates: 'Start: 01/01/1995 | Last Modified: 07/01/2017'
    } as ICarHelper,
    {
      code: '11',
      description:
        'The diagnosis is inconsistent with the procedure. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present.',
      dates: 'Start: 01/01/1995 | Last Modified: 07/01/2017'
    } as ICarHelper,
    {
      code: '12',
      description:
        'The diagnosis is inconsistent with the provider type. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present.',
      dates: 'Start: 01/01/1995 | Last Modified: 07/01/2017'
    } as ICarHelper,
    {
      code: '13',
      description: 'The date of death precedes the date of service.',
      dates: 'Start: 01/01/1995'
    } as ICarHelper,
    {
      code: '14',
      description: 'The date of birth follows the date of service.',
      dates: 'Start: 01/01/1995'
    } as ICarHelper,
    {
      code: '15',
      description:
        'The authorization number is missing, invalid, or does not apply to the billed services or provider.',
      dates: 'Start: 01/01/1995 | Last Modified: 11/01/2017 | Stop: 05/01/2018'
    } as ICarHelper,
    {
      code: '16',
      description:
        'Claim/service lacks information or has submission/billing error(s). Usage: Do not use this code for claims attachment(s)/other documentation. At least one Remark Code must be provided (may be comprised of either the NCPDP Reject Reason Code, or Remittance Advice Remark Code that is not an ALERT.) Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present.',
      dates: 'Start: 01/01/1995 | Last Modified: 03/01/2018'
    } as ICarHelper,
    {
      code: '17',
      description:
        'Requested information was not provided or was insufficient/incomplete. At least one Remark Code must be provided (may be comprised of either the Remittance Advice Remark Code or NCPDP Reject Reason Code.)',
      dates: 'Start: 01/01/1995 | Last Modified: 09/21/2008 | Stop: 07/01/2009'
    } as ICarHelper,
    {
      code: '18',
      description:
        "Exact duplicate claim/service (Use only with Group Code OA except where state workers' compensation regulations requires CO)",
      dates: 'Start: 01/01/1995 | Last Modified: 06/02/2013'
    } as ICarHelper,
    {
      code: '19',
      description:
        "This is a work-related injury/illness and thus the liability of the Worker's Compensation Carrier.",
      dates: 'Start: 01/01/1995 | Last Modified: 09/30/2007'
    } as ICarHelper,
    {
      code: '20',
      description: 'This injury/illness is covered by the liability carrier.',
      dates: 'Start: 01/01/1995 | Last Modified: 09/30/2007'
    } as ICarHelper,
    {
      code: '21',
      description: 'This injury/illness is the liability of the no-fault carrier.',
      dates: 'Start: 01/01/1995 | Last Modified: 09/30/2007'
    } as ICarHelper,
    {
      code: '22',
      description: 'This care may be covered by another payer per coordination of benefits.',
      dates: 'Start: 01/01/1995 | Last Modified: 09/30/2007'
    } as ICarHelper,
    {
      code: '23',
      description:
        'The impact of prior payer(s) adjudication including payments and/or adjustments. (Use only with Group Code OA)',
      dates: 'Start: 01/01/1995 | Last Modified: 09/30/2012'
    } as ICarHelper,
    {
      code: '24',
      description: 'Charges are covered under a capitation agreement/managed care plan.',
      dates: 'Start: 01/01/1995 | Last Modified: 09/30/2007'
    } as ICarHelper,
    {
      code: '25',
      description: 'Payment denied. Your Stop loss deductible has not been met.',
      dates: 'Start: 01/01/1995 | Stop: 04/01/2008'
    } as ICarHelper,
    {
      code: '26',
      description: 'Expenses incurred prior to coverage.',
      dates: 'Start: 01/01/1995'
    } as ICarHelper,
    {
      code: '27',
      description: 'Expenses incurred after coverage terminated.',
      dates: 'Start: 01/01/1995'
    } as ICarHelper,
    {
      code: '28',
      description: 'Coverage not in effect at the time the service was provided.',
      dates: 'Start: 01/01/1995 | Stop: 10/16/2003Notes: Redundant to codes 26&27.'
    } as ICarHelper,
    {
      code: '29',
      description: 'The time limit for filing has expired.',
      dates: 'Start: 01/01/1995'
    } as ICarHelper,
    {
      code: '30',
      description:
        'Payment adjusted because the patient has not met the required eligibility, spend down, waiting, or residency requirements.',
      dates: 'Start: 01/01/1995 | Stop: 02/01/2006'
    } as ICarHelper,
    {
      code: '31',
      description: 'Patient cannot be identified as our insured.',
      dates: 'Start: 01/01/1995 | Last Modified: 09/30/2007'
    } as ICarHelper,
    {
      code: '32',
      description: 'Our records indicate the patient is not an eligible dependent.',
      dates: 'Start: 01/01/1995 | Last Modified: 03/01/2018'
    } as ICarHelper,
    {
      code: '33',
      description: 'Insured has no dependent coverage.',
      dates: 'Start: 01/01/1995 | Last Modified: 09/30/2007'
    } as ICarHelper,
    {
      code: '34',
      description: 'Insured has no coverage for newborns.',
      dates: 'Start: 01/01/1995 | Last Modified: 09/30/2007'
    } as ICarHelper,
    {
      code: '35',
      description: 'Lifetime benefit maximum has been reached.',
      dates: 'Start: 01/01/1995 | Last Modified: 10/31/2002'
    } as ICarHelper,
    {
      code: '36',
      description: 'Balance does not exceed co-payment amount.',
      dates: 'Start: 01/01/1995 | Stop: 10/16/2003'
    } as ICarHelper,
    {
      code: '37',
      description: 'Balance does not exceed deductible.',
      dates: 'Start: 01/01/1995 | Stop: 10/16/2003'
    } as ICarHelper,
    {
      code: '38',
      description:
        'Services not provided or authorized by designated (network/primary care) providers.',
      dates:
        'Start: 01/01/1995 | Last Modified: 06/02/2013 | Stop: 01/01/2013Notes: CARC codes 242 and 243 are replacements for this deactivated code'
    } as ICarHelper,
    {
      code: '39',
      description: 'Services denied at the time authorization/pre-certification was requested.',
      dates: 'Start: 01/01/1995'
    } as ICarHelper,
    {
      code: '40',
      description:
        'Charges do not meet qualifications for emergent/urgent care. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present.',
      dates: 'Start: 01/01/1995 | Last Modified: 07/01/2017'
    } as ICarHelper,
    {
      code: '41',
      description: 'Discount agreed to in Preferred Provider contract.',
      dates: 'Start: 01/01/1995 | Stop: 10/16/2003'
    } as ICarHelper,
    {
      code: '42',
      description: 'Charges exceed our fee schedule or maximum allowable amount. (Use CARC 45)',
      dates: 'Start: 01/01/1995 | Last Modified: 10/31/2006 | Stop: 06/01/2007'
    } as ICarHelper,
    {
      code: '43',
      description: 'Gramm-Rudman reduction.',
      dates: 'Start: 01/01/1995 | Stop: 07/01/2006'
    } as ICarHelper,
    {
      code: '44',
      description: 'Prompt-pay discount.',
      dates: 'Start: 01/01/1995'
    } as ICarHelper,
    {
      code: '45',
      description:
        'Charge exceeds fee schedule/maximum allowable or contracted/legislated fee arrangement. Usage: This adjustment amount cannot equal the total service or claim charge amount; and must not duplicate provider adjustment amounts (payments and contractual reductions) that have resulted from prior payer(s) adjudication. (Use only with Group Codes PR or CO depending upon liability)',
      dates: 'Start: 01/01/1995 | Last Modified: 07/01/2017'
    } as ICarHelper,
    {
      code: '46',
      description: 'This (these) service(s) is (are) not covered.',
      dates: 'Start: 01/01/1995 | Stop: 10/16/2003Notes: Use code 96.'
    } as ICarHelper,
    {
      code: '47',
      description: 'This (these) diagnosis(es) is (are) not covered, missing, or are invalid.',
      dates: 'Start: 01/01/1995 | Stop: 02/01/2006'
    } as ICarHelper,
    {
      code: '48',
      description: 'This (these) procedure(s) is (are) not covered.',
      dates: 'Start: 01/01/1995 | Stop: 10/16/2003Notes: Use code 96.'
    } as ICarHelper,
    {
      code: '49',
      description:
        'This is a non-covered service because it is a routine/preventive exam or a diagnostic/screening procedure done in conjunction with a routine/preventive exam. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present.',
      dates: 'Start: 01/01/1995 | Last Modified: 07/01/2017'
    } as ICarHelper,
    {
      code: '50',
      description:
        "These are non-covered services because this is not deemed a 'medical necessity' by the payer. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present.",
      dates: 'Start: 01/01/1995 | Last Modified: 07/01/2017'
    } as ICarHelper,
    {
      code: '51',
      description:
        'These are non-covered services because this is a pre-existing condition. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present.',
      dates: 'Start: 01/01/1995 | Last Modified: 07/01/2017'
    } as ICarHelper,
    {
      code: '52',
      description:
        'The referring/prescribing/rendering provider is not eligible to refer/prescribe/order/perform the service billed.',
      dates: 'Start: 01/01/1995 | Stop: 02/01/2006'
    } as ICarHelper,
    {
      code: '53',
      description:
        'Services by an immediate relative or a member of the same household are not covered.',
      dates: 'Start: 01/01/1995'
    } as ICarHelper,
    {
      code: '54',
      description:
        'Multiple physicians/assistants are not covered in this case. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present.',
      dates: 'Start: 01/01/1995 | Last Modified: 07/01/2017'
    } as ICarHelper,
    {
      code: '55',
      description:
        'Procedure/treatment/drug is deemed experimental/investigational by the payer. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present.',
      dates: 'Start: 01/01/1995 | Last Modified: 07/01/2017'
    } as ICarHelper,
    {
      code: '56',
      description:
        "Procedure/treatment has not been deemed 'proven to be effective' by the payer. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present.",
      dates: 'Start: 01/01/1995 | Last Modified: 07/01/2017'
    } as ICarHelper,
    {
      code: '57',
      description:
        "Payment denied/reduced because the payer deems the information submitted does not support this level of service, this many services, this length of service, this dosage, or this day's supply.",
      dates:
        'Start: 01/01/1995 | Stop: 06/30/2007Notes: Split into codes 150, 151, 152, 153 and 154.'
    } as ICarHelper,
    {
      code: '58',
      description:
        'Treatment was deemed by the payer to have been rendered in an inappropriate or invalid place of service. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present.',
      dates: 'Start: 01/01/1995 | Last Modified: 07/01/2017'
    } as ICarHelper,
    {
      code: '59',
      description:
        'Processed based on multiple or concurrent procedure rules. (For example multiple surgery or diagnostic imaging, concurrent anesthesia.) Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present.',
      dates: 'Start: 01/01/1995 | Last Modified: 07/01/2017'
    } as ICarHelper,
    {
      code: '60',
      description:
        'Charges for outpatient services are not covered when performed within a period of time prior to or after inpatient services.',
      dates: 'Start: 01/01/1995 | Last Modified: 06/01/2008'
    } as ICarHelper,
    {
      code: '61',
      description: 'Adjusted for failure to obtain second surgical opinion',
      dates:
        'Start: 01/01/1995 | Last Modified: 03/01/2017Notes: The description effective date was inadvertently published as 3/1/2016 on 7/1/2016. That has been corrected to 1/1/2017.'
    } as ICarHelper,
    {
      code: '62',
      description:
        'Payment denied/reduced for absence of, or exceeded, pre-certification/authorization.',
      dates: 'Start: 01/01/1995 | Last Modified: 10/31/2006 | Stop: 04/01/2007'
    } as ICarHelper,
    {
      code: '63',
      description: 'Correction to a prior claim.',
      dates: 'Start: 01/01/1995 | Stop: 10/16/2003'
    } as ICarHelper,
    {
      code: '64',
      description: 'Denial reversed per Medical Review.',
      dates: 'Start: 01/01/1995 | Stop: 10/16/2003'
    } as ICarHelper,
    {
      code: '65',
      description: 'Procedure code was incorrect. This payment reflects the correct code.',
      dates: 'Start: 01/01/1995 | Stop: 10/16/2003'
    } as ICarHelper,
    {
      code: '66',
      description: 'Blood Deductible.',
      dates: 'Start: 01/01/1995'
    } as ICarHelper,
    {
      code: '67',
      description: 'Lifetime reserve days. (Handled in QTY, QTY01=LA)',
      dates: 'Start: 01/01/1995 | Stop: 10/16/2003'
    } as ICarHelper,
    {
      code: '68',
      description: 'DRG weight. (Handled in CLP12)',
      dates: 'Start: 01/01/1995 | Stop: 10/16/2003'
    } as ICarHelper,
    {
      code: '69',
      description: 'Day outlier amount.',
      dates: 'Start: 01/01/1995'
    } as ICarHelper,
    {
      code: '70',
      description: 'Cost outlier - Adjustment to compensate for additional costs.',
      dates: 'Start: 01/01/1995 | Last Modified: 06/30/2001'
    } as ICarHelper,
    {
      code: '71',
      description: 'Primary Payer amount.',
      dates: 'Start: 01/01/1995 | Stop: 06/30/2000Notes: Use code 23.'
    } as ICarHelper,
    {
      code: '72',
      description: 'Coinsurance day. (Handled in QTY, QTY01=CD)',
      dates: 'Start: 01/01/1995 | Stop: 10/16/2003'
    } as ICarHelper,
    {
      code: '73',
      description: 'Administrative days.',
      dates: 'Start: 01/01/1995 | Stop: 10/16/2003'
    } as ICarHelper,
    {
      code: '74',
      description: 'Indirect Medical Education Adjustment.',
      dates: 'Start: 01/01/1995'
    } as ICarHelper,
    {
      code: '75',
      description: 'Direct Medical Education Adjustment.',
      dates: 'Start: 01/01/1995'
    } as ICarHelper,
    {
      code: '76',
      description: 'Disproportionate Share Adjustment.',
      dates: 'Start: 01/01/1995'
    } as ICarHelper,
    {
      code: '77',
      description: 'Covered days. (Handled in QTY, QTY01=CA)',
      dates: 'Start: 01/01/1995 | Stop: 10/16/2003'
    } as ICarHelper,
    {
      code: '78',
      description: 'Non-Covered days/Room charge adjustment.',
      dates: 'Start: 01/01/1995'
    } as ICarHelper,
    {
      code: '79',
      description: 'Cost Report days. (Handled in MIA15)',
      dates: 'Start: 01/01/1995 | Stop: 10/16/2003'
    } as ICarHelper,
    {
      code: '80',
      description: 'Outlier days. (Handled in QTY, QTY01=OU)',
      dates: 'Start: 01/01/1995 | Stop: 10/16/2003'
    } as ICarHelper,
    {
      code: '81',
      description: 'Discharges.',
      dates: 'Start: 01/01/1995 | Stop: 10/16/2003'
    } as ICarHelper,
    {
      code: '82',
      description: 'PIP days.',
      dates: 'Start: 01/01/1995 | Stop: 10/16/2003'
    } as ICarHelper,
    {
      code: '83',
      description: 'Total visits.',
      dates: 'Start: 01/01/1995 | Stop: 10/16/2003'
    } as ICarHelper,
    {
      code: '84',
      description: 'Capital Adjustment. (Handled in MIA)',
      dates: 'Start: 01/01/1995 | Stop: 10/16/2003'
    } as ICarHelper,
    {
      code: '85',
      description: 'Patient Interest Adjustment (Use Only Group code PR)',
      dates:
        'Start: 01/01/1995 | Last Modified: 07/09/2007Notes: Only use when the payment of interest is the responsibility of the patient.'
    } as ICarHelper,
    {
      code: '86',
      description: 'Statutory Adjustment.',
      dates: 'Start: 01/01/1995 | Stop: 10/16/2003Notes: Duplicative of code 45.'
    } as ICarHelper,
    {
      code: '87',
      description: 'Transfer amount.',
      dates: 'Start: 01/01/1995 | Last Modified: 09/20/2009 | Stop: 01/01/2012'
    } as ICarHelper,
    {
      code: '88',
      description:
        'Adjustment amount represents collection against receivable created in prior overpayment.',
      dates: 'Start: 01/01/1995 | Stop: 06/30/2007'
    } as ICarHelper,
    {
      code: '89',
      description: 'Professional fees removed from charges.',
      dates: 'Start: 01/01/1995'
    } as ICarHelper,
    {
      code: '90',
      description: 'Ingredient cost adjustment. Usage: To be used for pharmaceuticals only.',
      dates: 'Start: 01/01/1995 | Last Modified: 07/01/2017'
    } as ICarHelper,
    {
      code: '91',
      description: 'Dispensing fee adjustment.',
      dates: 'Start: 01/01/1995'
    } as ICarHelper,
    {
      code: '92',
      description: 'Claim Paid in full.',
      dates: 'Start: 01/01/1995 | Stop: 10/16/2003'
    } as ICarHelper,
    {
      code: '93',
      description: 'No Claim level Adjustments.',
      dates:
        'Start: 01/01/1995 | Stop: 10/16/2003Notes: As of 004010, CAS at the claim level is optional.'
    } as ICarHelper,
    {
      code: '94',
      description: 'Processed in Excess of charges.',
      dates: 'Start: 01/01/1995'
    } as ICarHelper,
    {
      code: '95',
      description: 'Plan procedures not followed.',
      dates: 'Start: 01/01/1995 | Last Modified: 09/30/2007'
    } as ICarHelper,
    {
      code: '96',
      description:
        'Non-covered charge(s). At least one Remark Code must be provided (may be comprised of either the NCPDP Reject Reason Code, or Remittance Advice Remark Code that is not an ALERT.) Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present.',
      dates: 'Start: 01/01/1995 | Last Modified: 07/01/2017'
    } as ICarHelper,
    {
      code: '97',
      description:
        'The benefit for this service is included in the payment/allowance for another service/procedure that has already been adjudicated. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present.',
      dates: 'Start: 01/01/1995 | Last Modified: 07/01/2017'
    } as ICarHelper,
    {
      code: '98',
      description:
        'The hospital must file the Medicare claim for this inpatient non-physician service.',
      dates: 'Start: 01/01/1995 | Stop: 10/16/2003'
    } as ICarHelper,
    {
      code: '99',
      description: 'Medicare Secondary Payer Adjustment Amount.',
      dates: 'Start: 01/01/1995 | Stop: 10/16/2003'
    } as ICarHelper,
    {
      code: '100',
      description:
        'Payment made to patient/insured/responsible party/employer. Effective 05/01/2018: Payment made to patient/insured/responsible party.',
      dates: 'Start: 01/01/1995 | Last Modified: 11/01/2017'
    } as ICarHelper,
    {
      code: '101',
      description:
        'Predetermination: anticipated payment upon completion of services or claim adjudication.',
      dates: 'Start: 01/01/1995 | Last Modified: 02/28/1999'
    } as ICarHelper,
    {
      code: '102',
      description: 'Major Medical Adjustment.',
      dates: 'Start: 01/01/1995'
    } as ICarHelper,
    {
      code: '103',
      description: 'Provider promotional discount (e.g., Senior citizen discount).',
      dates: 'Start: 01/01/1995 | Last Modified: 06/30/2001'
    } as ICarHelper,
    {
      code: '104',
      description: 'Managed care withholding.',
      dates: 'Start: 01/01/1995'
    } as ICarHelper,
    {
      code: '105',
      description: 'Tax withholding.',
      dates: 'Start: 01/01/1995'
    } as ICarHelper,
    {
      code: '106',
      description: 'Patient payment option/election not in effect.',
      dates: 'Start: 01/01/1995'
    } as ICarHelper,
    {
      code: '107',
      description:
        'The related or qualifying claim/service was not identified on this claim. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present.',
      dates: 'Start: 01/01/1995 | Last Modified: 07/01/2017'
    } as ICarHelper,
    {
      code: '108',
      description:
        'Rent/purchase guidelines were not met. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present.',
      dates: 'Start: 01/01/1995 | Last Modified: 07/01/2017'
    } as ICarHelper,
    {
      code: '109',
      description:
        'Claim/service not covered by this payer/contractor. You must send the claim/service to the correct payer/contractor.',
      dates: 'Start: 01/01/1995 | Last Modified: 01/29/2012'
    } as ICarHelper,
    {
      code: '110',
      description: 'Billing date predates service date.',
      dates: 'Start: 01/01/1995'
    } as ICarHelper,
    {
      code: '111',
      description: 'Not covered unless the provider accepts assignment.',
      dates: 'Start: 01/01/1995'
    } as ICarHelper,
    {
      code: '112',
      description: 'Service not furnished directly to the patient and/or not documented.',
      dates: 'Start: 01/01/1995 | Last Modified: 09/30/2007'
    } as ICarHelper,
    {
      code: '113',
      description:
        'Payment denied because service/procedure was provided outside the United States or as a result of war.',
      dates:
        'Start: 01/01/1995 | Last Modified: 02/28/2001 | Stop: 06/30/2007Notes: Use Codes 157, 158 or 159.'
    } as ICarHelper,
    {
      code: '114',
      description: 'Procedure/product not approved by the Food and Drug Administration.',
      dates: 'Start: 01/01/1995'
    } as ICarHelper,
    {
      code: '115',
      description: 'Procedure postponed, canceled, or delayed.',
      dates: 'Start: 01/01/1995 | Last Modified: 09/30/2007'
    } as ICarHelper,
    {
      code: '116',
      description:
        'The advance indemnification notice signed by the patient did not comply with requirements.',
      dates: 'Start: 01/01/1995 | Last Modified: 09/30/2007'
    } as ICarHelper,
    {
      code: '117',
      description:
        'Transportation is only covered to the closest facility that can provide the necessary care.',
      dates: 'Start: 01/01/1995 | Last Modified: 09/30/2007'
    } as ICarHelper,
    {
      code: '118',
      description: 'ESRD network support adjustment.',
      dates: 'Start: 01/01/1995 | Last Modified: 09/30/2007'
    } as ICarHelper,
    {
      code: '119',
      description: 'Benefit maximum for this time period or occurrence has been reached.',
      dates: 'Start: 01/01/1995 | Last Modified: 02/29/2004'
    } as ICarHelper,
    {
      code: '120',
      description: 'Patient is covered by a managed care plan.',
      dates: 'Start: 01/01/1995 | Stop: 06/30/2007Notes: Use code 24.'
    } as ICarHelper,
    {
      code: '121',
      description:
        'Indemnification adjustment - compensation for outstanding member responsibility.',
      dates: 'Start: 01/01/1995 | Last Modified: 09/30/2007'
    } as ICarHelper,
    {
      code: '122',
      description: 'Psychiatric reduction.',
      dates: 'Start: 01/01/1995'
    } as ICarHelper,
    {
      code: '123',
      description: 'Payer refund due to overpayment.',
      dates:
        'Start: 01/01/1995 | Stop: 06/30/2007Notes: Refer to implementation guide for proper handling of reversals.'
    } as ICarHelper,
    {
      code: '124',
      description: 'Payer refund amount - not our patient.',
      dates:
        'Start: 01/01/1995 | Last Modified: 06/30/1999 | Stop: 06/30/2007Notes: Refer to implementation guide for proper handling of reversals.'
    } as ICarHelper,
    {
      code: '125',
      description:
        'Submission/billing error(s). At least one Remark Code must be provided (may be comprised of either the NCPDP Reject Reason Code, or Remittance Advice Remark Code that is not an ALERT.)',
      dates: 'Start: 01/01/1995 | Last Modified: 09/20/2009 | Stop: 11/01/2013'
    } as ICarHelper,
    {
      code: '126',
      description: 'Deductible -- Major Medical',
      dates:
        'Start: 02/28/1997 | Last Modified: 09/30/2007 | Stop: 04/01/2008Notes: Use Group Code PR and code 1.'
    } as ICarHelper,
    {
      code: '127',
      description: 'Coinsurance -- Major Medical',
      dates:
        'Start: 02/28/1997 | Last Modified: 09/30/2007 | Stop: 04/01/2008Notes: Use Group Code PR and code 2.'
    } as ICarHelper,
    {
      code: '128',
      description: "Newborn's services are covered in the mother's Allowance.",
      dates: 'Start: 02/28/1997'
    } as ICarHelper,
    {
      code: '129',
      description:
        'Prior processing information appears incorrect. At least one Remark Code must be provided (may be comprised of either the NCPDP Reject Reason Code, or Remittance Advice Remark Code that is not an ALERT.)',
      dates: 'Start: 02/28/1997 | Last Modified: 01/30/2011'
    } as ICarHelper,
    {
      code: '130',
      description: 'Claim submission fee.',
      dates: 'Start: 02/28/1997 | Last Modified: 06/30/2001'
    } as ICarHelper,
    {
      code: '131',
      description: 'Claim specific negotiated discount.',
      dates: 'Start: 02/28/1997'
    } as ICarHelper,
    {
      code: '132',
      description: 'Prearranged demonstration project adjustment.',
      dates: 'Start: 02/28/1997'
    } as ICarHelper,
    {
      code: '133',
      description:
        'The disposition of this service line is pending further review. (Use only with Group Code OA). Usage: Use of this code requires a reversal and correction when the service line is finalized (use only in Loop 2110 CAS segment of the 835 or Loop 2430 of the 837).',
      dates: 'Start: 07/01/2014 | Last Modified: 07/01/2017'
    } as ICarHelper,
    {
      code: '134',
      description: 'Technical fees removed from charges.',
      dates: 'Start: 10/31/1998'
    } as ICarHelper,
    {
      code: '135',
      description: 'Interim bills cannot be processed.',
      dates: 'Start: 10/31/1998 | Last Modified: 09/30/2007'
    } as ICarHelper,
    {
      code: '136',
      description: "Failure to follow prior payer's coverage rules. (Use only with Group Code OA)",
      dates: 'Start: 10/31/1998 | Last Modified: 07/01/2013'
    } as ICarHelper,
    {
      code: '137',
      description: 'Regulatory Surcharges, Assessments, Allowances or Health Related Taxes.',
      dates: 'Start: 02/28/1999 | Last Modified: 09/30/2007'
    } as ICarHelper,
    {
      code: '138',
      description: 'Appeal procedures not followed or time limits not met.',
      dates: 'Start: 06/30/1999 | Last Modified: 11/01/2017 | Stop: 05/01/2018'
    } as ICarHelper,
    {
      code: '139',
      description:
        'Contracted funding agreement - Subscriber is employed by the provider of services. Effective 05/01/2018: Contracted funding agreement - Subscriber is employed by the provider of services. Use only with Group Code CO.',
      dates: 'Start: 06/30/1999 | Last Modified: 11/01/2017'
    } as ICarHelper,
    {
      code: '140',
      description: 'Patient/Insured health identification number and name do not match.',
      dates: 'Start: 06/30/1999'
    } as ICarHelper,
    {
      code: '141',
      description: 'Claim spans eligible and ineligible periods of coverage.',
      dates: 'Start: 06/30/1999 | Last Modified: 09/30/2007 | Stop: 07/01/2012'
    } as ICarHelper,
    {
      code: '142',
      description: 'Monthly Medicaid patient liability amount.',
      dates: 'Start: 06/30/2000 | Last Modified: 09/30/2007'
    } as ICarHelper,
    {
      code: '143',
      description: 'Portion of payment deferred.',
      dates: 'Start: 02/28/2001'
    } as ICarHelper,
    {
      code: '144',
      description: 'Incentive adjustment, e.g. preferred product/service.',
      dates: 'Start: 06/30/2001'
    } as ICarHelper,
    {
      code: '145',
      description: 'Premium payment withholding',
      dates:
        'Start: 06/30/2002 | Last Modified: 09/30/2007 | Stop: 04/01/2008Notes: Use Group Code CO and code 45.'
    } as ICarHelper,
    {
      code: '146',
      description: 'Diagnosis was invalid for the date(s) of service reported.',
      dates: 'Start: 06/30/2002 | Last Modified: 09/30/2007'
    } as ICarHelper,
    {
      code: '147',
      description: 'Provider contracted/negotiated rate expired or not on file.',
      dates: 'Start: 06/30/2002'
    } as ICarHelper,
    {
      code: '148',
      description:
        'Information from another provider was not provided or was insufficient/incomplete. At least one Remark Code must be provided (may be comprised of either the NCPDP Reject Reason Code, or Remittance Advice Remark Code that is not an ALERT.)',
      dates: 'Start: 06/30/2002 | Last Modified: 09/20/2009'
    } as ICarHelper,
    {
      code: '149',
      description: 'Lifetime benefit maximum has been reached for this service/benefit category.',
      dates: 'Start: 10/31/2002'
    } as ICarHelper,
    {
      code: '150',
      description: 'Payer deems the information submitted does not support this level of service.',
      dates: 'Start: 10/31/2002 | Last Modified: 09/30/2007'
    } as ICarHelper,
    {
      code: '151',
      description:
        'Payment adjusted because the payer deems the information submitted does not support this many/frequency of services.',
      dates: 'Start: 10/31/2002 | Last Modified: 01/27/2008'
    } as ICarHelper,
    {
      code: '152',
      description:
        'Payer deems the information submitted does not support this length of service. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present.',
      dates: 'Start: 10/31/2002 | Last Modified: 07/01/2017'
    } as ICarHelper,
    {
      code: '153',
      description: 'Payer deems the information submitted does not support this dosage.',
      dates: 'Start: 10/31/2002 | Last Modified: 09/30/2007'
    } as ICarHelper,
    {
      code: '154',
      description: "Payer deems the information submitted does not support this day's supply.",
      dates: 'Start: 10/31/2002 | Last Modified: 09/30/2007'
    } as ICarHelper,
    {
      code: '155',
      description: 'Patient refused the service/procedure.',
      dates: 'Start: 06/30/2003 | Last Modified: 09/30/2007'
    } as ICarHelper,
    {
      code: '156',
      description: 'Flexible spending account payments. Note: Use code 187.',
      dates: 'Start: 09/30/2003 | Last Modified: 01/25/2009 | Stop: 10/01/2009'
    } as ICarHelper,
    {
      code: '157',
      description: 'Service/procedure was provided as a result of an act of war.',
      dates: 'Start: 09/30/2003 | Last Modified: 09/30/2007'
    } as ICarHelper,
    {
      code: '158',
      description: 'Service/procedure was provided outside of the United States.',
      dates: 'Start: 09/30/2003 | Last Modified: 09/30/2007'
    } as ICarHelper,
    {
      code: '159',
      description: 'Service/procedure was provided as a result of terrorism.',
      dates: 'Start: 09/30/2003 | Last Modified: 09/30/2007'
    } as ICarHelper,
    {
      code: '160',
      description: 'Injury/illness was the result of an activity that is a benefit exclusion.',
      dates: 'Start: 09/30/2003 | Last Modified: 09/30/2007'
    } as ICarHelper,
    {
      code: '161',
      description: 'Provider performance bonus',
      dates: 'Start: 02/29/2004'
    } as ICarHelper,
    {
      code: '162',
      description:
        'State-mandated Requirement for Property and Casualty, see Claim Payment Remarks Code for specific explanation.',
      dates: 'Start: 02/29/2004 | Stop: 07/01/2014Notes: Use code P1'
    } as ICarHelper,
    {
      code: '163',
      description: 'Attachment/other documentation referenced on the claim was not received.',
      dates: 'Start: 06/30/2004 | Last Modified: 06/02/2013'
    } as ICarHelper,
    {
      code: '164',
      description:
        'Attachment/other documentation referenced on the claim was not received in a timely fashion.',
      dates: 'Start: 06/30/2004 | Last Modified: 06/02/2013'
    } as ICarHelper,
    {
      code: '165',
      description: 'Referral absent or exceeded.',
      dates: 'Start: 10/31/2004 | Last Modified: 11/01/2017 | Stop: 05/01/2018'
    } as ICarHelper,
    {
      code: '166',
      description:
        'These services were submitted after this payers responsibility for processing claims under this plan ended.',
      dates: 'Start: 02/28/2005'
    } as ICarHelper,
    {
      code: '167',
      description:
        'This (these) diagnosis(es) is (are) not covered. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present.',
      dates: 'Start: 06/30/2005 | Last Modified: 07/01/2017'
    } as ICarHelper,
    {
      code: '168',
      description:
        "Service(s) have been considered under the patient's medical plan. Benefits are not available under this dental plan.",
      dates: 'Start: 06/30/2005 | Last Modified: 11/01/2017 | Stop: 05/01/2018'
    } as ICarHelper,
    {
      code: '169',
      description: 'Alternate benefit has been provided.',
      dates: 'Start: 06/30/2005 | Last Modified: 09/30/2007'
    } as ICarHelper,
    {
      code: '170',
      description:
        'Payment is denied when performed/billed by this type of provider. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present.',
      dates: 'Start: 06/30/2005 | Last Modified: 07/01/2017'
    } as ICarHelper,
    {
      code: '171',
      description:
        'Payment is denied when performed/billed by this type of provider in this type of facility. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present.',
      dates: 'Start: 06/30/2005 | Last Modified: 07/01/2017'
    } as ICarHelper,
    {
      code: '172',
      description:
        'Payment is adjusted when performed/billed by a provider of this specialty. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present.',
      dates: 'Start: 06/30/2005 | Last Modified: 07/01/2017'
    } as ICarHelper,
    {
      code: '173',
      description: 'Service/equipment was not prescribed by a physician.',
      dates: 'Start: 06/30/2005 | Last Modified: 07/01/2013'
    } as ICarHelper,
    {
      code: '174',
      description: 'Service was not prescribed prior to delivery.',
      dates: 'Start: 06/30/2005 | Last Modified: 09/30/2007'
    } as ICarHelper,
    {
      code: '175',
      description: 'Prescription is incomplete.',
      dates: 'Start: 06/30/2005 | Last Modified: 09/30/2007'
    } as ICarHelper,
    {
      code: '176',
      description: 'Prescription is not current.',
      dates: 'Start: 06/30/2005 | Last Modified: 09/30/2007'
    } as ICarHelper,
    {
      code: '177',
      description: 'Patient has not met the required eligibility requirements.',
      dates: 'Start: 06/30/2005 | Last Modified: 09/30/2007'
    } as ICarHelper,
    {
      code: '178',
      description: 'Patient has not met the required spend down requirements.',
      dates: 'Start: 06/30/2005 | Last Modified: 09/30/2007'
    } as ICarHelper,
    {
      code: '179',
      description:
        'Patient has not met the required waiting requirements. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present.',
      dates: 'Start: 06/30/2005 | Last Modified: 03/01/2017'
    } as ICarHelper,
    {
      code: '180',
      description: 'Patient has not met the required residency requirements.',
      dates: 'Start: 06/30/2005 | Last Modified: 09/30/2007'
    } as ICarHelper,
    {
      code: '181',
      description: 'Procedure code was invalid on the date of service.',
      dates: 'Start: 06/30/2005 | Last Modified: 09/30/2007'
    } as ICarHelper,
    {
      code: '182',
      description: 'Procedure modifier was invalid on the date of service.',
      dates: 'Start: 06/30/2005 | Last Modified: 09/30/2007'
    } as ICarHelper,
    {
      code: '183',
      description:
        'The referring provider is not eligible to refer the service billed. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present.',
      dates: 'Start: 06/30/2005 | Last Modified: 07/01/2017'
    } as ICarHelper,
    {
      code: '184',
      description:
        'The prescribing/ordering provider is not eligible to prescribe/order the service billed. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present.',
      dates: 'Start: 06/30/2005 | Last Modified: 07/01/2017'
    } as ICarHelper,
    {
      code: '185',
      description:
        'The rendering provider is not eligible to perform the service billed. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present.',
      dates: 'Start: 06/30/2005 | Last Modified: 07/01/2017'
    } as ICarHelper,
    {
      code: '186',
      description: 'Level of care change adjustment.',
      dates: 'Start: 06/30/2005 | Last Modified: 09/30/2007'
    } as ICarHelper,
    {
      code: '187',
      description:
        'Consumer Spending Account payments (includes but is not limited to Flexible Spending Account, Health Savings Account, Health Reimbursement Account, etc.)',
      dates: 'Start: 06/30/2005 | Last Modified: 01/25/2009'
    } as ICarHelper,
    {
      code: '188',
      description:
        'This product/procedure is only covered when used according to FDA recommendations.',
      dates: 'Start: 06/30/2005'
    } as ICarHelper,
    {
      code: '189',
      description:
        "'Not otherwise classified' or 'unlisted' procedure code (CPT/HCPCS) was billed when there is a specific procedure code for this procedure/service",
      dates: 'Start: 06/30/2005'
    } as ICarHelper,
    {
      code: '190',
      description:
        'Payment is included in the allowance for a Skilled Nursing Facility (SNF) qualified stay.',
      dates: 'Start: 10/31/2005'
    } as ICarHelper,
    {
      code: '191',
      description:
        "Not a work related injury/illness and thus not the liability of the workers' compensation carrier Note: If adjustment is at the Claim Level, the payer must send and the provider should refer to the 835 Insurance Policy Number Segment (Loop 2100 Other Claim Related Information REF qualifier 'IG') for the jurisdictional regulation. If adjustment is at the Line Level, the payer must send and the provider should refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment information REF)",
      dates: 'Start: 10/31/2005 | Last Modified: 10/17/2010 | Stop: 07/01/2014Notes: Use code P2'
    } as ICarHelper,
    {
      code: '192',
      description:
        'Non standard adjustment code from paper remittance. Usage: This code is to be used by providers/payers providing Coordination of Benefits information to another payer in the 837 transaction only. This code is only used when the non-standard code cannot be reasonably mapped to an existing Claims Adjustment Reason Code, specifically Deductible, Coinsurance and Co-payment.',
      dates: 'Start: 10/31/2005 | Last Modified: 07/01/2017'
    } as ICarHelper,
    {
      code: '193',
      description:
        'Original payment decision is being maintained. Upon review, it was determined that this claim was processed properly.',
      dates: 'Start: 02/28/2006 | Last Modified: 01/27/2008'
    } as ICarHelper,
    {
      code: '194',
      description:
        'Anesthesia performed by the operating physician, the assistant surgeon or the attending physician.',
      dates: 'Start: 02/28/2006 | Last Modified: 09/30/2007'
    } as ICarHelper,
    {
      code: '195',
      description: 'Refund issued to an erroneous priority payer for this claim/service.',
      dates: 'Start: 02/28/2006 | Last Modified: 09/30/2007'
    } as ICarHelper,
    {
      code: '196',
      description: "Claim/service denied based on prior payer's coverage determination.",
      dates: 'Start: 06/30/2006 | Stop: 02/01/2007Notes: Use code 136.'
    } as ICarHelper,
    {
      code: '197',
      description:
        'Precertification/authorization/notification absent. Effective 05/01/2018: Precertification/authorization/notification/pre-treatment absent.',
      dates: 'Start: 10/31/2006 | Last Modified: 11/01/2017'
    } as ICarHelper,
    {
      code: '198',
      description:
        'Precertification/authorization exceeded. Effective 05/01/2018: Precertification/notification/authorization/pre-treatment exceeded.',
      dates: 'Start: 10/31/2006 | Last Modified: 11/01/2017'
    } as ICarHelper,
    {
      code: '199',
      description: 'Revenue code and Procedure code do not match.',
      dates: 'Start: 10/31/2006'
    } as ICarHelper,
    {
      code: '200',
      description: 'Expenses incurred during lapse in coverage',
      dates: 'Start: 10/31/2006'
    } as ICarHelper,
    {
      code: '201',
      description:
        "Patient is responsible for amount of this claim/service through 'set aside arrangement' or other agreement. (Use only with Group Code PR)  At least one Remark Code must be provided (may be comprised of either the NCPDP Reject Reason Code, or Remittance Advice Remark Code that is not an ALERT.)",
      dates:
        "Start: 10/31/2006 | Last Modified: 09/28/2014Notes: Not for use by Workers' Compensation payers; use code P3 instead."
    } as ICarHelper,
    {
      code: '202',
      description: 'Non-covered personal comfort or convenience services.',
      dates: 'Start: 02/28/2007 | Last Modified: 09/30/2007'
    } as ICarHelper,
    {
      code: '203',
      description: 'Discontinued or reduced service.',
      dates: 'Start: 02/28/2007 | Last Modified: 09/30/2007'
    } as ICarHelper,
    {
      code: '204',
      description:
        'This service/equipment/drug is not covered under the patient’s current benefit plan',
      dates: 'Start: 02/28/2007'
    } as ICarHelper,
    {
      code: '205',
      description: 'Pharmacy discount card processing fee',
      dates: 'Start: 07/09/2007'
    } as ICarHelper,
    {
      code: '206',
      description: 'National Provider Identifier - missing.',
      dates: 'Start: 07/09/2007 | Last Modified: 09/30/2007'
    } as ICarHelper,
    {
      code: '207',
      description: 'National Provider identifier - Invalid format',
      dates: 'Start: 07/09/2007 | Last Modified: 06/01/2008'
    } as ICarHelper,
    {
      code: '208',
      description: 'National Provider Identifier - Not matched.',
      dates: 'Start: 07/09/2007 | Last Modified: 09/30/2007'
    } as ICarHelper,
    {
      code: '209',
      description:
        'Per regulatory or other agreement. The provider cannot collect this amount from the patient. However, this amount may be billed to subsequent payer. Refund to patient if collected. (Use only with Group code OA)',
      dates: 'Start: 07/09/2007 | Last Modified: 07/01/2013'
    } as ICarHelper,
    {
      code: '210',
      description:
        'Payment adjusted because pre-certification/authorization not received in a timely fashion',
      dates: 'Start: 07/09/2007'
    } as ICarHelper,
    {
      code: '211',
      description: 'National Drug Codes (NDC) not eligible for rebate, are not covered.',
      dates: 'Start: 07/09/2007'
    } as ICarHelper,
    {
      code: '212',
      description: 'Administrative surcharges are not covered',
      dates: 'Start: 11/05/2007'
    } as ICarHelper,
    {
      code: '213',
      description:
        'Non-compliance with the physician self referral prohibition legislation or payer policy.',
      dates: 'Start: 01/27/2008'
    } as ICarHelper,
    {
      code: '214',
      description:
        "Workers' Compensation claim adjudicated as non-compensable. This Payer not liable for claim or service/treatment. Note: If adjustment is at the Claim Level, the payer must send and the provider should refer to the 835 Insurance Policy Number Segment (Loop 2100 Other Claim Related Information REF qualifier 'IG') for the jurisdictional regulation. If adjustment is at the Line Level, the payer must send and the provider should refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment information REF). To be used for Workers' Compensation only",
      dates: 'Start: 01/27/2008 | Last Modified: 10/17/2010 | Stop: 07/01/2014Notes: Use code P4'
    } as ICarHelper,
    {
      code: '215',
      description: 'Based on subrogation of a third party settlement',
      dates: 'Start: 01/27/2008'
    } as ICarHelper,
    {
      code: '216',
      description: 'Based on the findings of a review organization',
      dates: 'Start: 01/27/2008'
    } as ICarHelper,
    {
      code: '217',
      description:
        'Based on payer reasonable and customary fees. No maximum allowable defined by legislated fee arrangement. (Note: To be used for Property and Casualty only)',
      dates: 'Start: 01/27/2008 | Last Modified: 09/30/2012 | Stop: 07/01/2014Notes: Use code P5'
    } as ICarHelper,
    {
      code: '218',
      description:
        "Based on entitlement to benefits. Note: If adjustment is at the Claim Level, the payer must send and the provider should refer to the 835 Insurance Policy Number Segment (Loop 2100 Other Claim Related Information REF qualifier 'IG') for the jurisdictional regulation. If adjustment is at the Line Level, the payer must send and the provider should refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment information REF). To be used for Workers' Compensation only",
      dates: 'Start: 01/27/2008 | Last Modified: 10/17/2010 | Stop: 07/01/2014Notes: Use code P6'
    } as ICarHelper,
    {
      code: '219',
      description:
        "Based on extent of injury. Usage: If adjustment is at the Claim Level, the payer must send and the provider should refer to the 835 Insurance Policy Number Segment (Loop 2100 Other Claim Related Information REF qualifier 'IG') for the jurisdictional regulation. If adjustment is at the Line Level, the payer must send and the provider should refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment information REF).",
      dates: 'Start: 01/27/2008 | Last Modified: 07/01/2017'
    } as ICarHelper,
    {
      code: '220',
      description:
        'The applicable fee schedule/fee database does not contain the billed code. Please resubmit a bill with the appropriate fee schedule/fee database code(s) that best describe the service(s) provided and supporting documentation if required. (Note: To be used for Property and Casualty only)',
      dates: 'Start: 01/27/2008 | Last Modified: 09/30/2012 | Stop: 07/01/2014Notes: Use code P7'
    } as ICarHelper,
    {
      code: '221',
      description:
        "Claim is under investigation. Note: If adjustment is at the Claim Level, the payer must send and the provider should refer to the 835 Insurance Policy Number Segment (Loop 2100 Other Claim Related Information REF qualifier 'IG') for the jurisdictional regulation. If adjustment is at the Line Level, the payer must send and the provider should refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment information REF). (Note: To be used by Property & Casualty only)",
      dates: 'Start: 01/27/2008 | Last Modified: 07/01/2013 | Stop: 07/01/2014Notes: Use code P8'
    } as ICarHelper,
    {
      code: '222',
      description:
        'Exceeds the contracted maximum number of hours/days/units by this provider for this period. This is not patient specific. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present.',
      dates: 'Start: 06/01/2008 | Last Modified: 07/01/2017'
    } as ICarHelper,
    {
      code: '223',
      description:
        'Adjustment code for mandated federal, state or local law/regulation that is not already covered by another code and is mandated before a new code can be created.',
      dates: 'Start: 06/01/2008'
    } as ICarHelper,
    {
      code: '224',
      description:
        'Patient identification compromised by identity theft. Identity verification required for processing this and future claims.',
      dates: 'Start: 06/01/2008'
    } as ICarHelper,
    {
      code: '225',
      description:
        'Penalty or Interest Payment by Payer (Only used for plan to plan encounter reporting within the 837)',
      dates: 'Start: 06/01/2008'
    } as ICarHelper,
    {
      code: '226',
      description:
        'Information requested from the Billing/Rendering Provider was not provided or not provided timely or was insufficient/incomplete. At least one Remark Code must be provided (may be comprised of either the NCPDP Reject Reason Code, or Remittance Advice Remark Code that is not an ALERT.)',
      dates: 'Start: 09/21/2008 | Last Modified: 07/01/2013'
    } as ICarHelper,
    {
      code: '227',
      description:
        'Information requested from the patient/insured/responsible party was not provided or was insufficient/incomplete. At least one Remark Code must be provided (may be comprised of either the NCPDP Reject Reason Code, or Remittance Advice Remark Code that is not an ALERT.)',
      dates: 'Start: 09/21/2008 | Last Modified: 09/20/2009'
    } as ICarHelper,
    {
      code: '228',
      description:
        'Denied for failure of this provider, another provider or the subscriber to supply requested information to a previous payer for their adjudication',
      dates: 'Start: 09/21/2008'
    } as ICarHelper,
    {
      code: '229',
      description:
        "Partial charge amount not considered by Medicare due to the initial claim Type of Bill being 12X. Usage: This code can only be used in the 837 transaction to convey Coordination of Benefits information when the secondary payer's cost avoidance policy allows providers to bypass claim submission to a prior payer. (Use only with Group Code PR)",
      dates: 'Start: 01/25/2009 | Last Modified: 07/01/2017'
    } as ICarHelper,
    {
      code: '230',
      description:
        'No available or correlating CPT/HCPCS code to describe this service. Note: Used only by Property and Casualty.',
      dates: 'Start: 01/25/2009 | Stop: 07/01/2014Notes: Use code P9'
    } as ICarHelper,
    {
      code: '231',
      description:
        'Mutually exclusive procedures cannot be done in the same day/setting. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present.',
      dates: 'Start: 07/01/2009 | Last Modified: 07/01/2017'
    } as ICarHelper,
    {
      code: '232',
      description:
        'Institutional Transfer Amount. Usage: Applies to institutional claims only and explains the DRG amount difference when the patient care crosses multiple institutions.',
      dates: 'Start: 11/01/2009 | Last Modified: 07/01/2017'
    } as ICarHelper,
    {
      code: '233',
      description:
        'Services/charges related to the treatment of a hospital-acquired condition or preventable medical error.',
      dates: 'Start: 01/24/2010'
    } as ICarHelper,
    {
      code: '234',
      description:
        'This procedure is not paid separately. At least one Remark Code must be provided (may be comprised of either the NCPDP Reject Reason Code, or Remittance Advice Remark Code that is not an ALERT.)',
      dates: 'Start: 01/24/2010'
    } as ICarHelper,
    {
      code: '235',
      description: 'Sales Tax',
      dates: 'Start: 06/06/2010'
    } as ICarHelper,
    {
      code: '236',
      description:
        'This procedure or procedure/modifier combination is not compatible with another procedure or procedure/modifier combination provided on the same day according to the National Correct Coding Initiative or workers compensation state regulations/ fee schedule requirements.',
      dates: 'Start: 01/30/2011 | Last Modified: 07/01/2013'
    } as ICarHelper,
    {
      code: '237',
      description:
        'Legislated/Regulatory Penalty. At least one Remark Code must be provided (may be comprised of either the NCPDP Reject Reason Code, or Remittance Advice Remark Code that is not an ALERT.)',
      dates: 'Start: 06/05/2011'
    } as ICarHelper,
    {
      code: '238',
      description:
        'Claim spans eligible and ineligible periods of coverage, this is the reduction for the ineligible period. (Use only with Group Code PR)',
      dates: 'Start: 03/01/2012 | Last Modified: 07/01/2013'
    } as ICarHelper,
    {
      code: '239',
      description:
        'Claim spans eligible and ineligible periods of coverage. Rebill separate claims.',
      dates: 'Start: 03/01/2012 | Last Modified: 01/29/2012'
    } as ICarHelper,
    {
      code: '240',
      description:
        "The diagnosis is inconsistent with the patient's birth weight. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present.",
      dates: 'Start: 06/03/2012 | Last Modified: 07/01/2017'
    } as ICarHelper,
    {
      code: '241',
      description: 'Low Income Subsidy (LIS) Co-payment Amount',
      dates: 'Start: 06/03/2012'
    } as ICarHelper,
    {
      code: '242',
      description: 'Services not provided by network/primary care providers.',
      dates:
        'Start: 06/03/2012 | Last Modified: 06/02/2013Notes: This code replaces deactivated code 38'
    } as ICarHelper,
    {
      code: '243',
      description: 'Services not authorized by network/primary care providers.',
      dates:
        'Start: 06/03/2012 | Last Modified: 06/02/2013Notes: This code replaces deactivated code 38'
    } as ICarHelper,
    {
      code: '244',
      description:
        'Payment reduced to zero due to litigation. Additional information will be sent following the conclusion of litigation. To be used for Property & Casualty only.',
      dates: 'Start: 09/30/2012 | Stop: 07/01/2014Notes: Use code P10'
    } as ICarHelper,
    {
      code: '245',
      description: 'Provider performance program withhold.',
      dates: 'Start: 09/30/2012'
    } as ICarHelper,
    {
      code: '246',
      description: 'This non-payable code is for required reporting only.',
      dates: 'Start: 09/30/2012'
    } as ICarHelper,
    {
      code: '247',
      description:
        'Deductible for Professional service rendered in an Institutional setting and billed on an Institutional claim.',
      dates:
        'Start: 09/30/2012Notes: For Medicare Bundled Payment use only, under the Patient Protection and Affordable Care Act (PPACA).'
    } as ICarHelper,
    {
      code: '248',
      description:
        'Coinsurance for Professional service rendered in an Institutional setting and billed on an Institutional claim.',
      dates:
        'Start: 09/30/2012Notes: For Medicare Bundled Payment use only, under the Patient Protection and Affordable Care Act (PPACA).'
    } as ICarHelper,
    {
      code: '249',
      description: 'This claim has been identified as a readmission. (Use only with Group Code CO)',
      dates: 'Start: 09/30/2012'
    } as ICarHelper,
    {
      code: '250',
      description:
        'The attachment/other documentation that was received was the incorrect attachment/document. The expected attachment/document is still missing. At least one Remark Code must be provided (may be comprised of either the NCPDP Reject Reason Code, or Remittance Advice Remark Code that is not an ALERT).',
      dates: 'Start: 09/30/2012 | Last Modified: 06/01/2014'
    } as ICarHelper,
    {
      code: '251',
      description:
        'The attachment/other documentation that was received was incomplete or deficient. The necessary information is still needed to process the claim. At least one Remark Code must be provided (may be comprised of either the NCPDP Reject Reason Code, or Remittance Advice Remark Code that is not an ALERT).',
      dates: 'Start: 09/30/2012 | Last Modified: 06/01/2014'
    } as ICarHelper,
    {
      code: '252',
      description:
        'An attachment/other documentation is required to adjudicate this claim/service. At least one Remark Code must be provided (may be comprised of either the NCPDP Reject Reason Code, or Remittance Advice Remark Code that is not an ALERT).',
      dates: 'Start: 09/30/2012 | Last Modified: 06/02/2013'
    } as ICarHelper,
    {
      code: '253',
      description: 'Sequestration - reduction in federal payment',
      dates: 'Start: 06/02/2013 | Last Modified: 11/01/2013'
    } as ICarHelper,
    {
      code: '254',
      description:
        "Claim received by the dental plan, but benefits not available under this plan.  Submit these services to the patient's medical plan for further consideration.",
      dates:
        'Start: 06/02/2013 | Last Modified: 11/01/2017Notes: Use CARC 290 if the claim was forwarded.'
    } as ICarHelper,
    {
      code: '255',
      description:
        'The disposition of the related Property & Casualty claim (injury or illness) is pending due to litigation. (Use only with Group Code OA)',
      dates: 'Start: 06/02/2013 | Stop: 07/01/2014Notes: Use code P11'
    } as ICarHelper,
    {
      code: '256',
      description: 'Service not payable per managed care contract.',
      dates: 'Start: 06/02/2013'
    } as ICarHelper,
    {
      code: '257',
      description:
        'The disposition of the claim/service is undetermined during the premium payment grace period, per Health Insurance Exchange requirements. This claim/service will be reversed and corrected when the grace period ends (due to premium payment or lack of premium payment). (Use only with Group Code OA)',
      dates:
        'Start: 11/01/2013 | Last Modified: 06/01/2014Notes: To be used after the first month of the grace period.'
    } as ICarHelper,
    {
      code: '258',
      description:
        'Claim/service not covered when patient is in custody/incarcerated. Applicable federal, state or local authority may cover the claim/service.',
      dates: 'Start: 11/01/2013'
    } as ICarHelper,
    {
      code: '259',
      description: 'Additional payment for Dental/Vision service utilization.',
      dates: 'Start: 01/26/2014'
    } as ICarHelper,
    {
      code: '260',
      description: 'Processed under Medicaid ACA Enhanced Fee Schedule',
      dates: 'Start: 01/26/2014'
    } as ICarHelper,
    {
      code: '261',
      description: "The procedure or service is inconsistent with the patient's history.",
      dates: 'Start: 06/01/2014'
    } as ICarHelper,
    {
      code: '262',
      description: 'Adjustment for delivery cost. Usage: To be used for pharmaceuticals only.',
      dates: 'Start: 11/01/2014 | Last Modified: 07/01/2017'
    } as ICarHelper,
    {
      code: '263',
      description: 'Adjustment for shipping cost. Usage: To be used for pharmaceuticals only.',
      dates: 'Start: 11/01/2014 | Last Modified: 07/01/2017'
    } as ICarHelper,
    {
      code: '264',
      description: 'Adjustment for postage cost. Usage: To be used for pharmaceuticals only.',
      dates: 'Start: 11/01/2014 | Last Modified: 07/01/2017'
    } as ICarHelper,
    {
      code: '265',
      description:
        'Adjustment for administrative cost. Usage: To be used for pharmaceuticals only.',
      dates: 'Start: 11/01/2014 | Last Modified: 07/01/2017'
    } as ICarHelper,
    {
      code: '266',
      description:
        'Adjustment for compound preparation cost. Usage: To be used for pharmaceuticals only.',
      dates: 'Start: 11/01/2014 | Last Modified: 07/01/2017'
    } as ICarHelper,
    {
      code: '267',
      description:
        'Claim/service spans multiple months. At least one Remark Code must be provided (may be comprised of either the NCPDP Reject Reason Code, or Remittance Advice Remark Code that is not an ALERT.)',
      dates: 'Start: 11/01/2014 | Last Modified: 04/01/2015'
    } as ICarHelper,
    {
      code: '268',
      description:
        'The Claim spans two calendar years. Please resubmit one claim per calendar year.',
      dates: 'Start: 11/01/2014'
    } as ICarHelper,
    {
      code: '269',
      description:
        'Anesthesia not covered for this service/procedure. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present.',
      dates: 'Start: 03/01/2015 | Last Modified: 07/01/2017'
    } as ICarHelper,
    {
      code: '270',
      description:
        'Claim received by the medical plan, but benefits not available under this plan. Submit these services to the patient’s dental plan for further consideration.',
      dates:
        'Start: 07/01/2015 | Last Modified: 11/01/2017Notes: Use CARC 291 if the claim was forwarded.'
    } as ICarHelper,
    {
      code: '271',
      description:
        'Prior contractual reductions related to a current periodic payment as part of a contractual payment schedule when deferred amounts have been previously reported. (Use only with Group Code OA)',
      dates: 'Start: 11/01/2015 | Last Modified: 03/01/2018'
    } as ICarHelper,
    {
      code: '272',
      description: 'Coverage/program guidelines were not met.',
      dates: 'Start: 11/01/2015'
    } as ICarHelper,
    {
      code: '273',
      description: 'Coverage/program guidelines were exceeded.',
      dates: 'Start: 11/01/2015'
    } as ICarHelper,
    {
      code: '274',
      description: 'Fee/Service not payable per patient Care Coordination arrangement.',
      dates: 'Start: 11/01/2015'
    } as ICarHelper,
    {
      code: '275',
      description:
        "Prior payer's (or payers') patient responsibility (deductible, coinsurance, co-payment) not covered. (Use only with Group Code PR)",
      dates: 'Start: 11/01/2015'
    } as ICarHelper,
    {
      code: '276',
      description: 'Services denied by the prior payer(s) are not covered by this payer.',
      dates: 'Start: 11/01/2015'
    } as ICarHelper,
    {
      code: '277',
      description:
        'The disposition of the claim/service is undetermined during the premium payment grace period, per Health Insurance SHOP Exchange requirements. This claim/service will be reversed and corrected when the grace period ends (due to premium payment or lack of premium payment). (Use only with Group Code OA)',
      dates: 'Start: 11/01/2015Notes: To be used during 31 day SHOP grace period.'
    } as ICarHelper,
    {
      code: '278',
      description:
        'Performance program proficiency requirements not met. (Use only with Group Codes CO or PI) Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present.',
      dates: 'Start: 07/01/2016 | Last Modified: 07/01/2017'
    } as ICarHelper,
    {
      code: '279',
      description:
        "Services not provided by Preferred network providers. Usage: Use this code when there are member network limitations. For example, using contracted providers not in the member's 'narrow' network.",
      dates: 'Start: 11/01/2016 | Last Modified: 07/01/2017'
    } as ICarHelper,
    {
      code: '280',
      description:
        "Claim received by the medical plan, but benefits not available under this plan. Submit these services to the patient's Pharmacy plan for further consideration.",
      dates:
        'Start: 03/01/2017 | Last Modified: 11/01/2017Notes: Use CARC 292 if the claim was forwarded.'
    } as ICarHelper,
    {
      code: '281',
      description: 'Deductible waived per contractual agreement. Use only with Group Code CO.',
      dates: 'Start: 07/01/2017'
    } as ICarHelper,
    {
      code: '282',
      description:
        'The procedure/revenue code is inconsistent with the type of bill. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present.',
      dates: 'Start: 07/01/2017'
    } as ICarHelper,
    {
      code: '283',
      description: 'Attending provider is not eligible to provide direction of care.',
      dates: 'Start: 11/01/2017'
    } as ICarHelper,
    {
      code: '284',
      description:
        'Precertification/authorization/notification/pre-treatment number may be valid but does not apply to the billed services.',
      dates: 'Start: 11/01/2017'
    } as ICarHelper,
    {
      code: '285',
      description: 'Appeal procedures not followed',
      dates: 'Start: 11/01/2017'
    } as ICarHelper,
    {
      code: '286',
      description: 'Appeal time limits not met',
      dates: 'Start: 11/01/2017'
    } as ICarHelper,
    {
      code: '287',
      description: 'Referral exceeded',
      dates: 'Start: 11/01/2017'
    } as ICarHelper,
    {
      code: '288',
      description: 'Referral absent',
      dates: 'Start: 11/01/2017'
    } as ICarHelper,
    {
      code: '289',
      description:
        'Services considered under the dental and medical plans, benefits not available.',
      dates: 'Start: 11/01/2017Notes: Also see CARCs 254, 270 and 280.'
    } as ICarHelper,
    {
      code: '290',
      description:
        "Claim received by the dental plan, but benefits not available under this plan. Claim has been forwarded to the patient's medical plan for further consideration.",
      dates: 'Start: 11/01/2017Notes: Use CARC 254 if the claim was not forwarded.'
    } as ICarHelper,
    {
      code: '291',
      description:
        "Claim received by the medical plan, but benefits not available under this plan. Claim has been forwarded to the patient's dental plan for further consideration.",
      dates: 'Start: 11/01/2017Notes: Use CARC 270 if the claim was not forwarded.'
    } as ICarHelper,
    {
      code: '292',
      description:
        "Claim received by the medical plan, but benefits not available under this plan. Claim has been forwarded to the patient's pharmacy plan for further consideration.",
      dates: 'Start: 11/01/2017Notes: Use CARC 280 if the claim was not forwarded.'
    } as ICarHelper,
    {
      code: '293',
      description: 'Payment made to employer.',
      dates: 'Start: 05/01/2018'
    } as ICarHelper,
    {
      code: '294',
      description: 'Payment made to attorney.',
      dates: 'Start: 11/01/2017'
    } as ICarHelper,
    {
      code: '295',
      description: 'Pharmacy Direct/Indirect Remuneration (DIR)',
      dates: 'Start: 03/01/2018'
    } as ICarHelper,
    {
      code: 'A0',
      description: 'Patient refund amount.',
      dates: 'Start: 01/01/1995'
    } as ICarHelper,
    {
      code: 'A1',
      description:
        'Claim/Service denied. At least one Remark Code must be provided (may be comprised of either the NCPDP Reject Reason Code, or Remittance Advice Remark Code that is not an ALERT.)',
      dates: 'Start: 01/01/1995 | Last Modified: 09/20/2009'
    } as ICarHelper,
    {
      code: 'A2',
      description: 'Contractual adjustment.',
      dates:
        "Start: 01/01/1995 | Last Modified: 02/28/2007 | Stop: 01/01/2008Notes: Use Code 45 with Group Code 'CO' or use another appropriate specific adjustment code."
    } as ICarHelper,
    {
      code: 'A3',
      description: 'Medicare Secondary Payer liability met.',
      dates: 'Start: 01/01/1995 | Stop: 10/16/2003'
    } as ICarHelper,
    {
      code: 'A4',
      description: 'Medicare Claim PPS Capital Day Outlier Amount.',
      dates: 'Start: 01/01/1995 | Last Modified: 09/30/2007 | Stop: 04/01/2008'
    } as ICarHelper,
    {
      code: 'A5',
      description: 'Medicare Claim PPS Capital Cost Outlier Amount.',
      dates: 'Start: 01/01/1995'
    } as ICarHelper,
    {
      code: 'A6',
      description: 'Prior hospitalization or 30 day transfer requirement not met.',
      dates: 'Start: 01/01/1995'
    } as ICarHelper,
    {
      code: 'A7',
      description: 'Presumptive Payment Adjustment',
      dates: 'Start: 01/01/1995 | Stop: 07/01/2015'
    } as ICarHelper,
    {
      code: 'A8',
      description: 'Ungroupable DRG.',
      dates: 'Start: 01/01/1995 | Last Modified: 09/30/2007'
    } as ICarHelper,
    {
      code: 'B1',
      description: 'Non-covered visits.',
      dates: 'Start: 01/01/1995'
    } as ICarHelper,
    {
      code: 'B2',
      description: 'Covered visits.',
      dates: 'Start: 01/01/1995 | Stop: 10/16/2003'
    } as ICarHelper,
    {
      code: 'B3',
      description: 'Covered charges.',
      dates: 'Start: 01/01/1995 | Stop: 10/16/2003'
    } as ICarHelper,
    {
      code: 'B4',
      description: 'Late filing penalty.',
      dates: 'Start: 01/01/1995'
    } as ICarHelper,
    {
      code: 'B5',
      description: 'Coverage/program guidelines were not met or were exceeded.',
      dates:
        'Start: 01/01/1995 | Last Modified: 11/01/2015 | Stop: 05/01/2016Notes: This code has been replaced by 272 and 273.'
    } as ICarHelper,
    {
      code: 'B6',
      description:
        'This payment is adjusted when performed/billed by this type of provider, by this type of provider in this type of facility, or by a provider of this specialty.',
      dates: 'Start: 01/01/1995 | Stop: 02/01/2006'
    } as ICarHelper,
    {
      code: 'B7',
      description:
        'This provider was not certified/eligible to be paid for this procedure/service on this date of service. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present.',
      dates: 'Start: 01/01/1995 | Last Modified: 07/01/2017'
    } as ICarHelper,
    {
      code: 'B8',
      description:
        'Alternative services were available, and should have been utilized. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present.',
      dates: 'Start: 01/01/1995 | Last Modified: 07/01/2017'
    } as ICarHelper,
    {
      code: 'B9',
      description: 'Patient is enrolled in a Hospice.',
      dates: 'Start: 01/01/1995 | Last Modified: 09/30/2007'
    } as ICarHelper,
    {
      code: 'B10',
      description:
        'Allowed amount has been reduced because a component of the basic procedure/test was paid. The beneficiary is not liable for more than the charge limit for the basic procedure/test.',
      dates: 'Start: 01/01/1995'
    } as ICarHelper,
    {
      code: 'B11',
      description:
        'The claim/service has been transferred to the proper payer/processor for processing. Claim/service not covered by this payer/processor.',
      dates: 'Start: 01/01/1995'
    } as ICarHelper,
    {
      code: 'B12',
      description: "Services not documented in patient's medical records.",
      dates: 'Start: 01/01/1995 | Last Modified: 03/01/2018'
    } as ICarHelper,
    {
      code: 'B13',
      description:
        'Previously paid. Payment for this claim/service may have been provided in a previous payment.',
      dates: 'Start: 01/01/1995'
    } as ICarHelper,
    {
      code: 'B14',
      description: 'Only one visit or consultation per physician per day is covered.',
      dates: 'Start: 01/01/1995 | Last Modified: 09/30/2007'
    } as ICarHelper,
    {
      code: 'B15',
      description:
        'This service/procedure requires that a qualifying service/procedure be received and covered. The qualifying other service/procedure has not been received/adjudicated. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present.',
      dates: 'Start: 01/01/1995 | Last Modified: 07/01/2017'
    } as ICarHelper,
    {
      code: 'B16',
      description: "'New Patient' qualifications were not met.",
      dates: 'Start: 01/01/1995 | Last Modified: 09/30/2007'
    } as ICarHelper,
    {
      code: 'B17',
      description:
        'Payment adjusted because this service was not prescribed by a physician, not prescribed prior to delivery, the prescription is incomplete, or the prescription is not current.',
      dates: 'Start: 01/01/1995 | Stop: 02/01/2006'
    } as ICarHelper,
    {
      code: 'B18',
      description: 'This procedure code and modifier were invalid on the date of service.',
      dates: 'Start: 01/01/1995 | Last Modified: 09/21/2008 | Stop: 03/01/2009'
    } as ICarHelper,
    {
      code: 'B19',
      description: 'Claim/service adjusted because of the finding of a Review Organization.',
      dates: 'Start: 01/01/1995 | Stop: 10/16/2003'
    } as ICarHelper,
    {
      code: 'B20',
      description: 'Procedure/service was partially or fully furnished by another provider.',
      dates: 'Start: 01/01/1995 | Last Modified: 09/30/2007'
    } as ICarHelper,
    {
      code: 'B21',
      description:
        'The charges were reduced because the service/care was partially furnished by another physician.',
      dates: 'Start: 01/01/1995 | Stop: 10/16/2003'
    } as ICarHelper,
    {
      code: 'B22',
      description: 'This payment is adjusted based on the diagnosis.',
      dates: 'Start: 01/01/1995 | Last Modified: 02/28/2001'
    } as ICarHelper,
    {
      code: 'B23',
      description:
        'Procedure billed is not authorized per your Clinical Laboratory Improvement Amendment (CLIA) proficiency test.',
      dates: 'Start: 01/01/1995 | Last Modified: 09/30/2007'
    } as ICarHelper,
    {
      code: 'D1',
      description: 'Claim/service denied. Level of subluxation is missing or inadequate.',
      dates: 'Start: 01/01/1995 | Stop: 10/16/2003Notes: Use code 16 and remark codes if necessary.'
    } as ICarHelper,
    {
      code: 'D2',
      description: 'Claim lacks the name, strength, or dosage of the drug furnished.',
      dates: 'Start: 01/01/1995 | Stop: 10/16/2003Notes: Use code 16 and remark codes if necessary.'
    } as ICarHelper,
    {
      code: 'D3',
      description:
        'Claim/service denied because information to indicate if the patient owns the equipment that requires the part or supply was missing.',
      dates: 'Start: 01/01/1995 | Stop: 10/16/2003Notes: Use code 16 and remark codes if necessary.'
    } as ICarHelper,
    {
      code: 'D4',
      description:
        'Claim/service does not indicate the period of time for which this will be needed.',
      dates: 'Start: 01/01/1995 | Stop: 10/16/2003Notes: Use code 16 and remark codes if necessary.'
    } as ICarHelper,
    {
      code: 'D5',
      description: 'Claim/service denied. Claim lacks individual lab codes included in the test.',
      dates: 'Start: 01/01/1995 | Stop: 10/16/2003Notes: Use code 16 and remark codes if necessary.'
    } as ICarHelper,
    {
      code: 'D6',
      description:
        "Claim/service denied. Claim did not include patient's medical record for the service.",
      dates: 'Start: 01/01/1995 | Stop: 10/16/2003Notes: Use code 16 and remark codes if necessary.'
    } as ICarHelper,
    {
      code: 'D7',
      description:
        "Claim/service denied. Claim lacks date of patient's most recent physician visit.",
      dates: 'Start: 01/01/1995 | Stop: 10/16/2003Notes: Use code 16 and remark codes if necessary.'
    } as ICarHelper,
    {
      code: 'D8',
      description:
        "Claim/service denied. Claim lacks indicator that 'x-ray is available for review.'",
      dates: 'Start: 01/01/1995 | Stop: 10/16/2003Notes: Use code 16 and remark codes if necessary.'
    } as ICarHelper,
    {
      code: 'D9',
      description:
        'Claim/service denied. Claim lacks invoice or statement certifying the actual cost of the lens, less discounts or the type of intraocular lens used.',
      dates: 'Start: 01/01/1995 | Stop: 10/16/2003Notes: Use code 16 and remark codes if necessary.'
    } as ICarHelper,
    {
      code: 'D10',
      description:
        'Claim/service denied. Completed physician financial relationship form not on file.',
      dates: 'Start: 01/01/1995 | Stop: 10/16/2003Notes: Use code 17.'
    } as ICarHelper,
    {
      code: 'D11',
      description: 'Claim lacks completed pacemaker registration form.',
      dates: 'Start: 01/01/1995 | Stop: 10/16/2003Notes: Use code 17.'
    } as ICarHelper,
    {
      code: 'D12',
      description:
        'Claim/service denied. Claim does not identify who performed the purchased diagnostic test or the amount you were charged for the test.',
      dates: 'Start: 01/01/1995 | Stop: 10/16/2003Notes: Use code 17.'
    } as ICarHelper,
    {
      code: 'D13',
      description:
        'Claim/service denied. Performed by a facility/supplier in which the ordering/referring physician has a financial interest.',
      dates: 'Start: 01/01/1995 | Stop: 10/16/2003Notes: Use code 17.'
    } as ICarHelper,
    {
      code: 'D14',
      description: 'Claim lacks indication that plan of treatment is on file.',
      dates: 'Start: 01/01/1995 | Stop: 10/16/2003Notes: Use code 17.'
    } as ICarHelper,
    {
      code: 'D15',
      description:
        'Claim lacks indication that service was supervised or evaluated by a physician.',
      dates: 'Start: 01/01/1995 | Stop: 10/16/2003Notes: Use code 17.'
    } as ICarHelper,
    {
      code: 'D16',
      description: 'Claim lacks prior payer payment information.',
      dates:
        'Start: 01/01/1995 | Stop: 06/30/2007Notes: Use code 16 with appropriate claim payment remark code [N4].'
    } as ICarHelper,
    {
      code: 'D17',
      description: 'Claim/Service has invalid non-covered days.',
      dates:
        'Start: 01/01/1995 | Stop: 06/30/2007Notes: Use code 16 with appropriate claim payment remark code.'
    } as ICarHelper,
    {
      code: 'D18',
      description: 'Claim/Service has missing diagnosis information.',
      dates:
        'Start: 01/01/1995 | Stop: 06/30/2007Notes: Use code 16 with appropriate claim payment remark code.'
    } as ICarHelper,
    {
      code: 'D19',
      description: 'Claim/Service lacks Physician/Operative or other supporting documentation',
      dates:
        'Start: 01/01/1995 | Stop: 06/30/2007Notes: Use code 16 with appropriate claim payment remark code.'
    } as ICarHelper,
    {
      code: 'D20',
      description: 'Claim/Service missing service/product information.',
      dates:
        'Start: 01/01/1995 | Stop: 06/30/2007Notes: Use code 16 with appropriate claim payment remark code.'
    } as ICarHelper,
    {
      code: 'D21',
      description: 'This (these) diagnosis(es) is (are) missing or are invalid',
      dates: 'Start: 01/01/1995 | Stop: 06/30/2007'
    } as ICarHelper,
    {
      code: 'D22',
      description:
        "Reimbursement was adjusted for the reasons to be provided in separate correspondence. (Note: To be used for Workers' Compensation only) - Temporary code to be added for timeframe only until 01/01/2009. Another code to be established and/or for 06/2008 meeting for a revised code to replace or strategy to use another existing code",
      dates: 'Start: 01/27/2008 | Stop: 01/01/2009'
    } as ICarHelper,
    {
      code: 'D23',
      description:
        'This dual eligible patient is covered by Medicare Part D per Medicare Retro-Eligibility.  At least one Remark Code must be provided (may be comprised of either the NCPDP Reject Reason Code, or Remittance Advice Remark Code that is not an ALERT.)',
      dates: 'Start: 11/01/2009 | Stop: 01/01/2012'
    } as ICarHelper,
    {
      code: 'P1',
      description:
        'State-mandated Requirement for Property and Casualty, see Claim Payment Remarks Code for specific explanation. To be used for Property and Casualty only.',
      dates: 'Start: 11/01/2013Notes: This code replaces deactivated code 162'
    } as ICarHelper,
    {
      code: 'P2',
      description:
        "Not a work related injury/illness and thus not the liability of the workers' compensation carrier Usage: If adjustment is at the Claim Level, the payer must send and the provider should refer to the 835 Insurance Policy Number Segment (Loop 2100 Other Claim Related Information REF qualifier 'IG') for the jurisdictional regulation. If adjustment is at the Line Level, the payer must send and the provider should refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment information REF). To be used for Workers' Compensation only.",
      dates:
        'Start: 11/01/2013 | Last Modified: 07/01/2017Notes: This code replaces deactivated code 191'
    } as ICarHelper,
    {
      code: 'P3',
      description:
        "Workers' Compensation case settled. Patient is responsible for amount of this claim/service through WC 'Medicare set aside arrangement' or other agreement. To be used for Workers' Compensation only. (Use only with Group Code PR)",
      dates: 'Start: 11/01/2013Notes: This code replaces deactivated code 201'
    } as ICarHelper,
    {
      code: 'P4',
      description:
        "Workers' Compensation claim adjudicated as non-compensable. This Payer not liable for claim or service/treatment. Usage: If adjustment is at the Claim Level, the payer must send and the provider should refer to the 835 Insurance Policy Number Segment (Loop 2100 Other Claim Related Information REF qualifier 'IG') for the jurisdictional regulation. If adjustment is at the Line Level, the payer must send and the provider should refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment information REF). To be used for Workers' Compensation only",
      dates:
        'Start: 11/01/2013 | Last Modified: 07/01/2017Notes: This code replaces deactivated code 214'
    } as ICarHelper,
    {
      code: 'P5',
      description:
        'Based on payer reasonable and customary fees. No maximum allowable defined by legislated fee arrangement. To be used for Property and Casualty only.',
      dates: 'Start: 11/01/2013Notes: This code replaces deactivated code 217'
    } as ICarHelper,
    {
      code: 'P6',
      description:
        "Based on entitlement to benefits. Usage: If adjustment is at the Claim Level, the payer must send and the provider should refer to the 835 Insurance Policy Number Segment (Loop 2100 Other Claim Related Information REF qualifier 'IG') for the jurisdictional regulation. If adjustment is at the Line Level, the payer must send and the provider should refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment information REF). To be used for Property and Casualty only.",
      dates:
        'Start: 11/01/2013 | Last Modified: 07/01/2017Notes: This code replaces deactivated code 218'
    } as ICarHelper,
    {
      code: 'P7',
      description:
        'The applicable fee schedule/fee database does not contain the billed code. Please resubmit a bill with the appropriate fee schedule/fee database code(s) that best describe the service(s) provided and supporting documentation if required. To be used for Property and Casualty only.',
      dates: 'Start: 11/01/2013Notes: This code replaces deactivated code 220'
    } as ICarHelper,
    {
      code: 'P8',
      description:
        "Claim is under investigation. Usage: If adjustment is at the Claim Level, the payer must send and the provider should refer to the 835 Insurance Policy Number Segment (Loop 2100 Other Claim Related Information REF qualifier 'IG') for the jurisdictional regulation. If adjustment is at the Line Level, the payer must send and the provider should refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment information REF). To be used for Property and Casualty only.",
      dates:
        'Start: 11/01/2013 | Last Modified: 07/01/2017Notes: This code replaces deactivated code 221'
    } as ICarHelper,
    {
      code: 'P9',
      description:
        'No available or correlating CPT/HCPCS code to describe this service. To be used for Property and Casualty only.',
      dates: 'Start: 11/01/2013Notes: This code replaces deactivated code 230'
    } as ICarHelper,
    {
      code: 'P10',
      description:
        'Payment reduced to zero due to litigation. Additional information will be sent following the conclusion of litigation. To be used for Property and Casualty only.',
      dates: 'Start: 11/01/2013Notes: This code replaces deactivated code 244'
    } as ICarHelper,
    {
      code: 'P11',
      description:
        'The disposition of the related Property & Casualty claim (injury or illness) is pending due to litigation. To be used for Property and Casualty only. (Use only with Group Code OA)',
      dates: 'Start: 11/01/2013Notes: This code replaces deactivated code 255'
    } as ICarHelper,
    {
      code: 'P12',
      description:
        "Workers' compensation jurisdictional fee schedule adjustment. Usage: If adjustment is at the Claim Level, the payer must send and the provider should refer to the 835 Class of Contract Code Identification Segment (Loop 2100 Other Claim Related Information REF). If adjustment is at the Line Level, the payer must send and the provider should refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment information REF) if the regulations apply. To be used for Workers' Compensation only.",
      dates:
        'Start: 11/01/2013 | Last Modified: 07/01/2017Notes: This code replaces deactivated code W1'
    } as ICarHelper,
    {
      code: 'P13',
      description:
        "Payment reduced or denied based on workers' compensation jurisdictional regulations or payment policies, use only if no other code is applicable. Usage: If adjustment is at the Claim Level, the payer must send and the provider should refer to the 835 Insurance Policy Number Segment (Loop 2100 Other Claim Related Information REF qualifier 'IG') if the jurisdictional regulation applies. If adjustment is at the Line Level, the payer must send and the provider should refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment information REF) if the regulations apply. To be used for Workers' Compensation only.",
      dates:
        'Start: 11/01/2013 | Last Modified: 07/01/2017Notes: This code replaces deactivated code W2'
    } as ICarHelper,
    {
      code: 'P14',
      description:
        'The Benefit for this Service is included in the payment/allowance for another service/procedure that has been performed on the same day. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present. To be used for Property and Casualty only.',
      dates:
        'Start: 11/01/2013 | Last Modified: 07/01/2017Notes: This code replaces deactivated code W3'
    } as ICarHelper,
    {
      code: 'P15',
      description:
        "Workers' Compensation Medical Treatment Guideline Adjustment. To be used for Workers' Compensation only.",
      dates: 'Start: 11/01/2013Notes: This code replaces deactivated code W4'
    } as ICarHelper,
    {
      code: 'P16',
      description:
        "Medical provider not authorized/certified to provide treatment to injured workers in this jurisdiction. To be used for Workers' Compensation only. (Use with Group Code CO or OA)",
      dates: 'Start: 11/01/2013Notes: This code replaces deactivated code W5'
    } as ICarHelper,
    {
      code: 'P17',
      description:
        'Referral not authorized by attending physician per regulatory requirement. To be used for Property and Casualty only.',
      dates: 'Start: 11/01/2013Notes: This code replaces deactivated code W6'
    } as ICarHelper,
    {
      code: 'P18',
      description:
        'Procedure is not listed in the jurisdiction fee schedule.  An allowance has been made for a comparable service. To be used for Property and Casualty only.',
      dates: 'Start: 11/01/2013Notes: This code replaces deactivated code W7'
    } as ICarHelper,
    {
      code: 'P19',
      description:
        'Procedure has a relative value of zero in the jurisdiction fee schedule, therefore no payment is due. To be used for Property and Casualty only.',
      dates: 'Start: 11/01/2013Notes: This code replaces deactivated code W8'
    } as ICarHelper,
    {
      code: 'P20',
      description:
        'Service not paid under jurisdiction allowed outpatient facility fee schedule. To be used for Property and Casualty only.',
      dates: 'Start: 11/01/2013Notes: This code replaces deactivated code W9'
    } as ICarHelper,
    {
      code: 'P21',
      description:
        "Payment denied based on the Medical Payments Coverage (MPC) and/or Personal Injury Protection (PIP) Benefits jurisdictional regulations, or payment policies. Usage: If adjustment is at the Claim Level, the payer must send and the provider should refer to the 835 Insurance Policy Number Segment (Loop 2100 Other Claim Related Information REF qualifier 'IG') if the jurisdictional regulation applies. If adjustment is at the Line Level, the payer must send and the provider should refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment information REF) if the regulations apply. To be used for Property and Casualty Auto only.",
      dates:
        'Start: 11/01/2013 | Last Modified: 03/01/2018Notes: This code replaces deactivated code Y1'
    } as ICarHelper,
    {
      code: 'P22',
      description:
        "Payment adjusted based on the Medical Payments Coverage (MPC) and/or Personal Injury Protection (PIP) Benefits jurisdictional regulations, or payment policies. Usage: If adjustment is at the Claim Level, the payer must send and the provider should refer to the 835 Insurance Policy Number Segment (Loop 2100 Other Claim Related Information REF qualifier 'IG') if the jurisdictional regulation applies. If adjustment is at the Line Level, the payer must send and the provider should refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment information REF) if the regulations apply. To be used for Property and Casualty Auto only.",
      dates:
        'Start: 11/01/2013 | Last Modified: 03/01/2018Notes: This code replaces deactivated code Y2'
    } as ICarHelper,
    {
      code: 'P23',
      description:
        'Medical Payments Coverage (MPC) or Personal Injury Protection (PIP) Benefits jurisdictional fee schedule adjustment. Usage: If adjustment is at the Claim Level, the payer must send and the provider should refer to the 835 Class of Contract Code Identification Segment (Loop 2100 Other Claim Related Information REF). If adjustment is at the Line Level, the payer must send and the provider should refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment information REF) if the regulations apply. To be used for Property and Casualty Auto only.',
      dates:
        'Start: 11/01/2013 | Last Modified: 07/01/2017Notes: This code replaces deactivated code Y3'
    } as ICarHelper,
    {
      code: 'P24',
      description:
        'Payment adjusted based on Preferred Provider Organization (PPO).  Usage: If adjustment is at the Claim Level, the payer must send and the provider should refer to the 835 Class of Contract Code Identification Segment (Loop 2100 Other Claim Related Information REF). If adjustment is at the Line Level, the payer must send and the provider should refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment information REF) if the regulations apply. To be used for Property and Casualty only. Use only with Group Code CO.',
      dates: 'Start: 11/01/2017'
    } as ICarHelper,
    {
      code: 'P25',
      description:
        'Payment adjusted based on Medical Provider Network (MPN).  Usage: If adjustment is at the Claim Level, the payer must send and the provider should refer to the 835 Class of Contract Code Identification Segment (Loop 2100 Other Claim Related Information REF). If adjustment is at the Line Level, the payer must send and the provider should refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment information REF) if the regulations apply. To be used for Property and Casualty only. (Use only with Group Code CO).',
      dates: 'Start: 11/01/2017'
    } as ICarHelper,
    {
      code: 'P26',
      description:
        'Payment adjusted based on Voluntary Provider network (VPN).  Usage: If adjustment is at the Claim Level, the payer must send and the provider should refer to the 835 Class of Contract Code Identification Segment (Loop 2100 Other Claim Related Information REF). If adjustment is at the Line Level, the payer must send and the provider should refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment information REF) if the regulations apply. To be used for Property and Casualty only. (Use only with Group Code CO).',
      dates: 'Start: 11/01/2017'
    } as ICarHelper,
    {
      code: 'P27',
      description:
        "Payment denied based on the Liability Coverage Benefits jurisdictional regulations and/or payment policies. Usage: If adjustment is at the Claim Level, the payer must send and the provider should refer to the 835 Insurance Policy Number Segment (Loop 2100 Other Claim Related Information REF qualifier 'IG') if the jurisdictional regulation applies. If adjustment is at the Line Level, the payer must send and the provider should refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment information REF) if the regulations apply. To be used for Property and Casualty Auto only.",
      dates: 'Start: 11/01/2017'
    } as ICarHelper,
    {
      code: 'P28',
      description:
        "Payment adjusted based on the Liability Coverage Benefits jurisdictional regulations and/or payment policies. Usage: If adjustment is at the Claim Level, the payer must send and the provider should refer to the 835 Insurance Policy Number Segment (Loop 2100 Other Claim Related Information REF qualifier 'IG') if the jurisdictional regulation applies. If adjustment is at the Line Level, the payer must send and the provider should refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment information REF) if the regulations apply. To be used for Property and Casualty Auto only.",
      dates: 'Start: 11/01/2017'
    } as ICarHelper,
    {
      code: 'P29',
      description:
        'Liability Benefits jurisdictional fee schedule adjustment. Usage: If adjustment is at the Claim Level, the payer must send and the provider should refer to the 835 Class of Contract Code Identification Segment (Loop 2100 Other Claim Related Information REF). If adjustment is at the Line Level, the payer must send and the provider should refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment information REF) if the regulations apply. To be used for Property and Casualty Auto only.',
      dates: 'Start: 11/01/2017'
    } as ICarHelper,
    {
      code: 'W1',
      description:
        "Workers' compensation jurisdictional fee schedule adjustment.  Note: If adjustment is at the Claim Level, the payer must send and the provider should refer to the 835 Class of Contract Code Identification Segment (Loop 2100 Other Claim Related Information REF). If adjustment is at the Line Level, the payer must send and the provider should refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment information REF) if the regulations apply.",
      dates: 'Start: 02/29/2000 | Last Modified: 06/02/2013 | Stop: 07/01/2014Notes: Use code P12'
    } as ICarHelper,
    {
      code: 'W2',
      description:
        "Payment reduced or denied based on workers' compensation jurisdictional regulations or payment policies, use only if no other code is applicable. Note: If adjustment is at the Claim Level, the payer must send and the provider should refer to the 835 Insurance Policy Number Segment (Loop 2100 Other Claim Related Information REF qualifier 'IG') if the jurisdictional regulation applies. If adjustment is at the Line Level, the payer must send and the provider should refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment information REF) if the regulations apply. To be used for Workers' Compensation only.",
      dates: 'Start: 10/17/2010 | Last Modified: 06/02/2013 | Stop: 07/01/2014Notes: Use code P13'
    } as ICarHelper,
    {
      code: 'W3',
      description:
        'The Benefit for this Service is included in the payment/allowance for another service/procedure that has been performed on the same day. Note: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present. For use by Property and Casualty only.',
      dates: 'Start: 09/30/2012 | Stop: 07/01/2014Notes: Use code P14'
    } as ICarHelper,
    {
      code: 'W4',
      description: "Workers' Compensation Medical Treatment Guideline Adjustment.",
      dates: 'Start: 09/30/2012 | Stop: 07/01/2014Notes: Use code P15'
    } as ICarHelper,
    {
      code: 'W5',
      description:
        'Medical provider not authorized/certified to provide treatment to injured workers in this jurisdiction. (Use with Group Code CO or OA)',
      dates: 'Start: 06/02/2013 | Stop: 07/01/2014Notes: Use code P16'
    } as ICarHelper,
    {
      code: 'W6',
      description: 'Referral not authorized by attending physician per regulatory requirement.',
      dates: 'Start: 06/02/2013 | Stop: 07/01/2014Notes: Use code P17'
    } as ICarHelper,
    {
      code: 'W7',
      description:
        'Procedure is not listed in the jurisdiction fee schedule.  An allowance has been made for a comparable service.',
      dates: 'Start: 06/02/2013 | Stop: 07/01/2014Notes: Use code P18'
    } as ICarHelper,
    {
      code: 'W8',
      description:
        'Procedure has a relative value of zero in the jurisdiction fee schedule, therefore no payment is due.',
      dates: 'Start: 06/02/2013 | Stop: 07/01/2014Notes: Use code P19'
    } as ICarHelper,
    {
      code: 'W9',
      description: 'Service not paid under jurisdiction allowed outpatient facility fee schedule.',
      dates: 'Start: 06/02/2013 | Stop: 07/01/2014Notes: Use code P20'
    } as ICarHelper,
    {
      code: 'Y1',
      description:
        "Payment denied based on Medical Payments Coverage (MPC) or Personal Injury Protection (PIP) Benefits jurisdictional regulations or payment policies, use only if no other code is applicable. Note: If adjustment is at the Claim Level, the payer must send and the provider should refer to the 835 Insurance Policy Number Segment (Loop 2100 Other Claim Related Information REF qualifier 'IG') if the jurisdictional regulation applies. If adjustment is at the Line Level, the payer must send and the provider should refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment information REF) if the regulations apply. To be used for P&C Auto only.",
      dates: 'Start: 09/30/2012 | Last Modified: 06/02/2013 | Stop: 07/01/2014Notes: Use code P21'
    } as ICarHelper,
    {
      code: 'Y2',
      description:
        "Payment adjusted based on Medical Payments Coverage (MPC) or Personal Injury Protection (PIP) Benefits jurisdictional regulations or payment policies, use only if no other code is applicable. Note: If adjustment is at the Claim Level, the payer must send and the provider should refer to the 835 Insurance Policy Number Segment (Loop 2100 Other Claim Related Information REF qualifier 'IG') if the jurisdictional regulation applies. If adjustment is at the Line Level, the payer must send and the provider should refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment information REF) if the regulations apply. To be used for P&C Auto only.",
      dates: 'Start: 09/30/2012 | Last Modified: 06/02/2013 | Stop: 07/01/2014Notes: Use code P22'
    } as ICarHelper,
    {
      code: 'Y3',
      description:
        'Medical Payments Coverage (MPC) or Personal Injury Protection (PIP) Benefits jurisdictional fee schedule adjustment. Note: If adjustment is at the Claim Level, the payer must send and the provider should refer to the 835 Class of Contract Code Identification Segment (Loop 2100 Other Claim Related Information REF). If adjustment is at the Line Level, the payer must send and the provider should refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment information REF) if the regulations apply. To be used for P&C Auto only.',
      dates: 'Start: 09/30/2012 | Last Modified: 06/02/2013 | Stop: 07/01/2014Notes: Use code P23'
    }
  ]
}
